import cx from "classnames";
import FieldWrapper from "../components/FieldWrapper";
import { ScaleFieldType } from "../types/feedbackFields.types";
import { FieldValueProps } from "./fields.types";
import { withSingleValue } from "./fields.utils";

// TODO: handle required
const ScaleField = ({ field, value, error, onChange }: { field: ScaleFieldType } & FieldValueProps<number>) => {
  const { _id, name, min, max, leftText, centerText, rightText } = field;
  const id = _id || name;

  const buttons = [];
  for (let i = min; i <= max; i++) {
    buttons.push(
      <button
        key={i}
        className={cx("c-button", { selected: i === value })}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onChange(id, i);
        }}
      >
        {i}
      </button>,
    );
  }

  return (
    <FieldWrapper field={field} error={error}>
      <div id={id} className="c-button-group">
        {buttons}
      </div>
      {(field.leftText || field.centerText || field.rightText) && (
        <div className="c-label-group">
          <div className="c-label">{leftText}</div>
          <div className="c-label">{centerText}</div>
          <div className="c-label">{rightText}</div>
        </div>
      )}
    </FieldWrapper>
  );
};
export default withSingleValue(ScaleField);
